<mat-form-field class="full-width">

  <mat-label ssFormLabel></mat-label>
  <ss-text-control></ss-text-control>
  <mat-error ssFormValidationMessage></mat-error>
  <mat-spinner diameter="24" *ngIf="(statusObs | async)==='PENDING'" matSuffix></mat-spinner>
  
  <button *ngIf="actionSubject | async" 
          mat-icon-button 
          matSuffix
          color="primary"
          (click)="executeActionCallback()"
          [matTooltip]="(actionSubject | async).tooltip | translate"
  >
    <mat-icon>{{(actionSubject | async).icon}}</mat-icon>
  </button>
</mat-form-field>